import { DocumentsEnum } from "@gtpl/shared-models/logistics";
import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty } from "class-validator";

export class UpdateDocumentUploadInfo{
    @ApiProperty()
    documentsApprovalId?:number;
    @ApiProperty()
    saleOrderId:number;
    @ApiProperty({ enum: Object.values(DocumentsEnum) })
    @IsNotEmpty()
    documentName:DocumentsEnum;
    @ApiProperty()
    status:boolean;
}